export function isSKU(query: string): boolean {
  return /^[A-Z0-9]{7}-[A-Z0-9]{5}-[A-Z0-9]{6}-[A-Z0-9]{3}$/.test(query);
}
